import { Trans } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import ScoreboardIcon from '@mui/icons-material/Scoreboard';
import { ROUTES } from '@routes/routes';
import { NotificationPresenter } from '@notifications/interfaces';
import { ScoreSubmissionDeletedByMemberNotificationData } from './interfaces';

const isScoreSubmissionDeletedByMemberPayload = (
  payload: unknown
): payload is ScoreSubmissionDeletedByMemberNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  return 'memberName' in payload && typeof payload.memberName === 'string';
};

export const scoreSubmissionDeletedByMemberPresenter: NotificationPresenter<ScoreSubmissionDeletedByMemberNotificationData> =
  {
    type: 'score-submission-deleted-by-member',
    icon: ScoreboardIcon,
    badgeIcon: DeleteIcon,
    isPayload: isScoreSubmissionDeletedByMemberPayload,
    label: (payload, t) =>
      t('notifications:types.score-submission-deleted-by-member', {
        memberName: payload.memberName,
        competitionName: payload.competitionName,
      }),
    message: (payload) => (
      <Trans
        i18nKey="notifications:menu.score-submission-deleted-by-member"
        values={{
          memberName: payload.memberName,
          competitionName: payload.competitionName,
        }}
        components={{
          bold: <strong />,
        }}
      />
    ),
    path: (payload) => {
      if (!payload.competitionSlug) {
        return null;
      }

      return ROUTES.manage.competitions.details(payload.competitionSlug);
    },
  };
